// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"982":"product-detail","983":"products"}[chunkId] || chunkId) + "." + {"163":"49a13655","594":"d1f18477","862":"b4d0c7dd","982":"c9629c58","983":"93696837"}[chunkId] + ".css";
};